export enum GlobalCalendarDayType {
  WORKING_DAY = 1,
  DAY_OFF = 2,
  SUNDAY_AND_HOLIDAY = 3,
}
